import 'react-fancybox/lib/fancybox.css';

import { Chip } from '@mui/material';
import axios from 'axios';
import Hashids from 'hashids';
import React, { useEffect } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import paginationFactory, {
  PaginationProvider,
  PaginationTotalStandalone,
  SizePerPageDropdownStandalone,
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { isMobile } from 'react-device-detect';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import Breadcrumb from '@/components/common/breadcrumb.component';
import DebounceSearchBar from '@/components/debounce-search-bar';
import Icon from '@/components/icon';
import NoDataIndicator from '@/components/no-data-indicator';
import StandalonePagination from '@/components/pagination/standalone';
import RowMoreOptions from '@/components/table/row-more-options';
import TableLoader from '@/components/table-loader';
import { Constants } from '@/constants';
import { UserStore } from '@/stores';

const hashids = new Hashids('', 12);

const defaultSorted = [
  {
    dataField: 'brand',
    order: 'asc',
  },
];

const cellEditProps = {
  mode: 'dbclick',
  beforeSaveCell(
    oldValue: any,
    newValue: any,
    row: any,
    column: any,
    done: any
  ) {
    console.log(`Before save for ${column.dataField}`);
    // TODO: call done() on success or done(false) on failure
  },
  afterSaveCell: (oldValue: any, newValue: any, row: any, column: any) => {
    console.log(`After save for ${column}`);
  },
};

const UserTable: React.FC<any> = () => {
  const { users, loadingUsers: loading } = UserStore.useState((s) => s);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const getUsers = (page, sizePerPage, searchText = undefined) => {
    axios
      .get(`${Constants.apiPath}/users/datatables/all`, {
        params: { page, limit: sizePerPage, q: searchText },
      })
      .then((res) => {
        if (page === 1) {
          UserStore.update((s) => {
            s.users = res.data.data;
            s.totalUserCount = res.data.recordsTotal;
          });
        } else {
          UserStore.update((s) => {
            s.users = [...s.users, ...res.data.data];
            s.totalUserCount = res.data.recordsTotal;
          });
        }
      })
      .catch((err) => {
        console.error(err);
        // TODO
      })
      .finally(() => {
        UserStore.update((s) => {
          s.loadingUsers = false;
        });
      });
  };

  useEffect(() => {
    // if (isMobile) {
    //   props.getAllCigars(state.page, state.sizePerPage);
    // }
    // // Only run once when the route loads to re-populate the table if necessary
    // if (searchParams?.has('q')) {
    //   setTimeout(() => {
    //     const query = searchParams.get('q');
    //     const { tableChangeType } = state;
    //     if (query !== state.searchText) {
    //       // FIXME Any way to prevent default fetching of handleTableChange on desktop?
    //       updateState({ searchText: query });
    //       handleTableChange(tableChangeType, {
    //         page: state.page,
    //         sizePerPage: state.sizePerPage,
    //         searchText: query,
    //       });
    //     }
    //   }, 250);
    // }
    getUsers(1, 30);
  }, []);

  const editBtnFormatter = (cell: any, row: any, index: number) => (
    <div style={{ minWidth: 68 }}>
      <div id={`dropdown-actions-${index}`} className="dropdown-actions d-none">
        <Icon
          name="edit2"
          className="ml-1 mr-3"
          style={{
            cursor: 'pointer',
            display: 'inline',
            height: 18,
            width: 18,
          }}
          onClick={() => {
            // const cigar = row;
            // navigate(
            //   `/cigars/editor/${cigar.hash_id || hashids.encode(cigar.id)}`,
            //   { state: { cigar } }
            // );
          }}
        />
        {actionDropdown(index, row)}
      </div>
    </div>
  );

  const updateRecords = () => {
    // const { page, sizePerPage, searchText, tableChangeType } = state;
    // handleTableChange(tableChangeType, {
    //   page: page - 1 > 0 ? page - 1 : 1,
    //   sizePerPage,
    //   searchText,
    // });
    // setTimeout(() => {
    //   handleTableChange(tableChangeType, { page, sizePerPage, searchText });
    // }, 50);
  };

  const handleRowChange = (updatedCigar: any) => {
    // const updatedCigars = state.cigars.map((cigar: any) =>
    //   cigar.id === updatedCigar.id ? { ...cigar, ...updatedCigar } : cigar
    // );
    updateRecords();
  };

  const handleRowDelete = (deletedCigar: any) => {
    // const updatedCigars = state.cigars.filter(
    //   (cigar: any) => cigar.id !== deletedCigar.id
    // );
  };

  const handleTableChange = (
    type: any,
    {
      page,
      sizePerPage,
      filters,
      sortField,
      sortOrder,
      cellEdit,
      searchText,
    }: any
  ) => {
    // if (!searchParams?.has('id')) {
    //   const pendingStatus =
    //     state.pendingStatus === 'pending' || state.pendingStatus === 'approved'
    //       ? state.pendingStatus
    //       : undefined;
    //   props.getAllCigars(
    //     page,
    //     sizePerPage,
    //     searchText && searchText.length > 0 ? searchText : null,
    //     pendingStatus
    //   );
    //   updateState({ tableChangeType: type, page, sizePerPage, searchText });
    // }
    // FIXME Move to redux/actions
    getUsers(page, sizePerPage, searchText);
  };

  const actionDropdown = (index: number, user: any) => (
    <RowMoreOptions
      row={index}
      items={[
        {
          type: 'MenuItem',
          onClick: () => {},
          title: 'Send Password Reset Email',
        },
        {
          type: 'MenuItem',
          onClick: () => {},
          style: { color: '#ff4700' },
          title: 'Deactivate',
        },
      ]}
      onShow={() => {
        const dropdownActions = document.querySelector(
          `#dropdown-actions-${index}`
        );
        if (dropdownActions) {
          dropdownActions.classList.add('d-none');
        }
      }}
    />
  );

  const columns = [
    {
      dataField: 'first_name',
      text: 'First Name',
      sort: true,
      headerClasses: 'sticky-header',
    },
    {
      dataField: 'last_name',
      text: 'Last Name',
      sort: true,
      headerClasses: 'sticky-header',
    },
    // TODO Additional info?
    {
      text: '',
      formatter: editBtnFormatter,
      sort: false,
      editable: false,
      headerClasses: 'sticky-header',
    },
  ];

  const rowEvents = {
    onMouseEnter: (e: any, row: any, index: number) => {
      document
        .querySelector(`#dropdown-actions-${index}`)
        ?.classList.remove('d-none');
    },
    onMouseLeave: (e: any, row: any, index: number) => {
      document
        .querySelector(`#dropdown-actions-${index}`)
        ?.classList.add('d-none');
    },
    // onDoubleClick: (e: any, row: any, index: number) => {
    //   // Double click event if needed
    // },
  };

  return (
    <div>
      <Breadcrumb title="User Manager" label="Manager" parent="Users" />

      <div className="container-fluid">
        {searchParams?.get('id') && (
          <Chip
            size="small"
            label={`id: ${searchParams?.get('id')}`}
            // onClick={clearQueryParams}
            // onDelete={clearQueryParams}
          />
        )}
        <div className="row">
          <div className="col-sm-12">
            <div
              className="m-b-10"
              style={
                isMobile ? { background: 'transparent', boxShadow: 'none' } : {}
              }
            >
              <div className="datatable-react">
                <ToolkitProvider
                  keyField="id"
                  data={users}
                  columns={columns}
                  search
                >
                  {(toolkitprops: any) => (
                    <div>
                      <div style={{ display: 'flex', marginTop: 20 }}>
                        {isMobile && (
                          <DebounceSearchBar
                            {...toolkitprops.searchProps}
                            placeholder="Search users..."
                            // onChange={() => updateState({ page: 1 })}
                            // onSearch={(query) => {
                            //   // INFO Since mobile doesn't use BootstrapTable, this needs managed manually
                            //   updateState({ searchText: query });
                            // }}
                          />
                        )}
                        {!isMobile && (
                          <div style={{ flex: 1 }}>
                            <DebounceSearchBar
                              {...toolkitprops.searchProps}
                              // value={state.searchText}
                              placeholder="Search users..."
                              // onChange={() => updateState({ page: 1 })}
                            />
                          </div>
                        )}
                      </div>
                      <PaginationProvider
                        pagination={paginationFactory({
                          // page: state.page,
                          // sizePerPage: state.sizePerPage,
                          // pageButtonRenderer,
                          custom: true,
                          // totalSize,
                          showTotal: true,
                          // onPageChange: handlePageChange,
                        })}
                      >
                        {({ paginationProps, paginationTableProps }: any) => (
                          <div>
                            <BootstrapTable
                              remote
                              keyField="id"
                              data={users}
                              columns={columns}
                              rowEvents={rowEvents}
                              defaultSorted={defaultSorted}
                              wrapperClasses="table-responsive"
                              {...paginationTableProps}
                              cellEdit={cellEditFactory(cellEditProps)}
                              onTableChange={handleTableChange}
                              noDataIndication={() =>
                                !loading ? (
                                  <NoDataIndicator message="No users found matching search query." />
                                ) : (
                                  <TableLoader />
                                )
                              }
                              {...toolkitprops.baseProps}
                            />
                            <PaginationTotalStandalone {...paginationProps} />
                            <div
                              style={{
                                width: 200,
                                display: 'inline-block',
                                float: 'right',
                              }}
                            />
                            <div style={{ display: 'flex', paddingBottom: 20 }}>
                              <div style={{ flex: 1 }}>
                                <StandalonePagination
                                  paginationProps={paginationProps}
                                />
                              </div>
                              <div>
                                <SizePerPageDropdownStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </PaginationProvider>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserTable;
